import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { ContactsDetails } from 'widgets/ContactsDetails'
import {
  BroadcastContactStatistics,
  BroadcastDetailHeader,
} from 'pages/broadcasts/ui/BroadcastDetail'
import { BroadcastContactStatisticsTable } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/ui/BroadcastContactStatisticsTable/BroadcastContactStatisticsTable'
import { BroadcastContactStatisticsSearch } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/ui/BroadcastContactStatisticsSearch/BroadcastContactStatisticsSearch'
import { useBroadcastDetailOneTimeContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/context/context'

export const Content = observer(() => {
  const store = useBroadcastDetailOneTimeContext()

  useEffect(() => {
    store.init()

    return () => {
      store.reset()
    }
  }, [])

  return (
    <FullPageWrapper>
      <BroadcastDetailHeader store={store} />
      <BroadcastContactStatistics
        filters={store.filters}
        onActiveFilter={store.onActiveFilter}
        filter={store.filter}
      />
      <BroadcastContactStatisticsSearch />
      <BroadcastContactStatisticsTable />
      {store.contactsDetailsStore && <ContactsDetails store={store.contactsDetailsStore} />}
    </FullPageWrapper>
  )
})
